import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { useTextColor } from '../../styles/jss/utils';
import { colors } from '../../styles/jss/variables';
import { SiteContext } from '../../utils/common';
import Icon from '../Icon/Icon';
import RawHtml from '../RawHtml/RawHtml';
import useStyles from './FeaturedFaqItem.styles';
export const DEFAULT_ITEM_BACKGROUND = colors.grey.grey1;
export const DEFAULT_SECTION_BACKGROUND = colors.supplementary.white;
export const MAX_FEATURED_FAQS = 4;
export const pickBackgroundColour = (option, fallback) => { var _a; return ((_a = option === null || option === void 0 ? void 0 : option[0]) === null || _a === void 0 ? void 0 : _a.backgroundColour) || fallback; };
export const isWhiteBackground = (hex) => !hex || hex.toUpperCase() === '#FFFFFF';
// textColor comes from shared useTextColor hook (#FFFFFF on dark backgrounds, #000000 otherwise)
export const getFeaturedTextColours = (textColor, isFlyingFlowers) => {
    if (textColor === colors.supplementary.white) {
        return { headingColour: colors.supplementary.white, bodyColour: colors.supplementary.white };
    }
    return isFlyingFlowers
        ? { headingColour: colors.black[700], bodyColour: colors.black[700] }
        : { headingColour: colors.supplementary.black, bodyColour: colors.grey.grey6 };
};
const FeaturedFaqItem = ({ question, answer, icon, showIcon = true, backgroundColour, anchorKey, questionTag, }) => {
    const { isFlyingFlowers } = useContext(SiteContext);
    const itemBackground = pickBackgroundColour(backgroundColour, DEFAULT_ITEM_BACKGROUND);
    const { textColor } = useTextColor(itemBackground);
    const { headingColour, bodyColour } = getFeaturedTextColours(textColor, !!isFlyingFlowers);
    const { classes } = useStyles({ backgroundColour: itemBackground, headingColour, bodyColour });
    const QuestionTag = (questionTag ? questionTag.toLowerCase() : 'h3');
    const hasIcon = showIcon && !!icon;
    const renderIcon = () => {
        var _a;
        if (!hasIcon || !icon)
            return null;
        if (typeof icon === 'object' && icon.url) {
            return (_jsx("span", { "aria-hidden": "true", children: _jsx("img", { src: icon.url, alt: (_a = icon.altText) !== null && _a !== void 0 ? _a : '', className: classes.iconImage, width: 32, height: 32 }) }));
        }
        if (typeof icon === 'string') {
            if (icon.startsWith('http') || icon.startsWith('/')) {
                return (_jsx("span", { "aria-hidden": "true", children: _jsx("img", { src: icon, alt: "", className: classes.iconImage, width: 32, height: 32 }) }));
            }
            return (_jsx("span", { "aria-hidden": "true", children: _jsx(Icon, { icon: icon, className: classes.icon }) }));
        }
        return null;
    };
    return (_jsxs("div", { className: classes.item, id: anchorKey || undefined, "data-testid": "featured-faq-item", children: [_jsxs("div", { className: classes.header, children: [renderIcon(), _jsx(QuestionTag, { className: classes.question, children: question })] }), _jsx(RawHtml, { content: answer, className: classes.answer })] }));
};
export default FeaturedFaqItem;
